var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.32 77.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "imagenes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1082",
    "data-name": "Grupo 1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1050",
    "data-name": "Grupo 1050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_893",
    "data-name": "Trazado 893",
    className: "cls-1",
    d: "M79.64,76.46h-70A8.7,8.7,0,0,1,1,67.78V9.68A8.68,8.68,0,0,1,9.68,1h70a8.68,8.68,0,0,1,8.68,8.68v58.1A8.68,8.68,0,0,1,79.64,76.46ZM9.68,2.92A6.77,6.77,0,0,0,2.92,9.68V67.77a6.78,6.78,0,0,0,6.76,6.76h70a6.78,6.78,0,0,0,6.76-6.76V9.68a6.76,6.76,0,0,0-6.76-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_894",
    "data-name": "Trazado 894",
    className: "cls-1",
    d: "M22.79,33.8a8.53,8.53,0,1,1,8.52-8.53A8.53,8.53,0,0,1,22.79,33.8Zm0-15.12a6.59,6.59,0,1,0,6.58,6.59h0A6.61,6.61,0,0,0,22.79,18.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_895",
    "data-name": "Trazado 895",
    className: "cls-1",
    d: "M13.24,64a1,1,0,0,1-1-1,1,1,0,0,1,.33-.73l25-22.05L56,58.72a1,1,0,0,1,0,1.37,1,1,0,0,1-1.36,0h0L37.56,43,13.88,63.79A.93.93,0,0,1,13.24,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_896",
    "data-name": "Trazado 896",
    className: "cls-1",
    d: "M78.43,53a.94.94,0,0,1-.68-.29l-17-17.15-16,13.17a1,1,0,0,1-1.24-1.49L60.83,32.94,79.11,51.35a1,1,0,0,1,0,1.37,1,1,0,0,1-.69.29Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.4b47178c2f1d972dc57170ae54c5076b.svg";
export { ForwardRef as ReactComponent };